import ANNOUNCEMENTS from './announcements';
import AUTH from './auth';
import BUTTONS from './buttons';
import CAMPAIGNS from './campaigns';
import COMMON from './common';
import COMPANY from './company';
import CONFIDENCEL_LEVELS from './confidenceLevels';
import CONSTITUENTS from './constituents';
import DONATIONS from './contributions';
import DATA_UPLOADS from './dataUploads';
import DONOR from './donor';
import DONORS from './donors';
import EMAIL_COMMS from './emailComms';
import EMPLOYEE from './employee';
import ERRORS from './errors';
import EVENTS from './events';
import FEED from './feed';
import FILTERS from './filters';
import FORMS from './forms';
import GOALS from './goals';
import HOME from './home';
import ICONS from './icons';
import INTEGRATIONS from './integrations';
import INTERACTIONS from './interactions';
import IWAVE from './iwave';
import LIFECYCLE_BOARDS from './lifecycleBoards';
import NAVIGATION from './navigation';
import OPPORTUNITIES from './opportunities';
import REPORTS from './reports';
import SALESFORCE from './salesforce';
import {
  BULK_IMPORT,
  FEATURE_FLAGS,
  ORG_MANAGEMENT,
  SUPER_ADMIN,
} from './superAdmin';
import TASKS from './tasks';
import USER from './user';

export default {
  ...ANNOUNCEMENTS,
  ...AUTH,
  ...BULK_IMPORT,
  ...BUTTONS,
  ...CAMPAIGNS,
  ...COMMON,
  ...COMPANY,
  ...CONFIDENCEL_LEVELS,
  ...CONSTITUENTS,
  ...DATA_UPLOADS,
  ...DONATIONS,
  ...DONOR,
  ...DONORS,
  ...EMAIL_COMMS,
  ...EMPLOYEE,
  ...ERRORS,
  ...EVENTS,
  ...FEATURE_FLAGS,
  ...FILTERS,
  ...FEED,
  ...FORMS,
  ...GOALS,
  ...HOME,
  ...ICONS,
  ...INTEGRATIONS,
  ...INTERACTIONS,
  ...IWAVE,
  ...LIFECYCLE_BOARDS,
  ...NAVIGATION,
  ...OPPORTUNITIES,
  ...ORG_MANAGEMENT,
  ...REPORTS,
  ...SALESFORCE,
  ...SUPER_ADMIN,
  ...TASKS,
  ...USER,
};
